<template>
  <v-card class="elevation-0 mt-0" flat>
    <v-card-title> Extratos </v-card-title>
    <v-progress-linear
      v-if="financialStatementIsLoading"
      color="primary"
      class="ma-3"
      indeterminate
    ></v-progress-linear>
    <v-expansion-panels v-else class="pa-3">
      <div v-if="financialStatement.length === 0 || !financialStatement">
        Nenhum extrato para ser exibido
      </div>
      <v-expansion-panel
        v-for="(statementOrder, key) in financialStatement"
        :key="key"
        class="elevation-1"
      >
        <v-expansion-panel-header>
          <b> #Pedido {{ key }} </b>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="statementOrder.data"
            class="elevation-0"
          >
            <template v-slot:item.description="{ item }">
              <td>{{ item.description }}</td>
            </template>
            <template v-slot:item.amount="{ item }">
              <td class="text-end">{{ formatCurrency(item.amount) }}</td>
            </template>
            <template v-slot:item.status="{ item }">
              <td class="text-end">
                <v-chip text-color="white" :color="getStatusColor(item.status)">
                  {{ item.status }}
                </v-chip>
              </td>
            </template>
            <template v-slot:item.paid_at="{ item }">
              <td class="text-end">{{ formatDate(item.paid_at) }}</td>
            </template>
            <template v-slot:item.due_at="{ item }">
              <td class="text-end">{{ formatDate(item.due_at) }}</td>
            </template>
            <template v-slot:item.charge_id="{ item }">
              <td class="text-end">
                <v-btn
                  small
                  :loading="generatingReceipt"
                  :disabled="!canIssueReceiptForThisCharge(item.charge_id)"
                  color="primary"
                  @click="issueReceipt(item.charge_id)"
                >
                  Gerar Recibo
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import UserService from "@/services/users.service";
export default {
  data() {
    return {
      financialStatementIsLoading: true,
      financialStatement: [],
      generatingReceipt: false,
      canIssueReceipt: [],
      headers: [
        { text: "Descrição", value: "description" },
        { text: "Total", value: "amount", align: "end" },
        { text: "Status", value: "status", align: "end" },
        { text: "Data Pagamento", value: "paid_at", align: "end" },
        { text: "Vencimento", value: "due_at", align: "end" },
        { text: "Ação", value: "charge_id", align: "end" },
      ],
    };
  },
  mounted() {
    this.financialStatement = UserService.getFinancialStatement()
      .then((response) => {
        this.financialStatement = response.data;
        this.financialStatementIsLoading = false;
      })
      .catch((error) => {
        console.error(error);
        this.financialStatementIsLoading = false;
      });
  },
  methods: {
    canIssueReceiptForThisCharge(chargeId) {
      return !this.canIssueReceipt.includes(chargeId);
    },
    getStatusColor(status) {
      switch (status.toLowerCase()) {
        case "pago":
          return "green";
        case "cancelada":
          return "red";
        case "em atraso":
          return "orange";
        default:
          return "blue";
      }
    },
    formatCurrency(amount) {
      return amount.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    formatDate(dateString) {
      if (dateString === null) return null;
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    issueReceipt(chargeId) {
      this.generatingReceipt = true;
      this.canIssueReceipt.push(chargeId);
      UserService.issueReceipt(chargeId)
        .then((response) => {
          const contentDisposition = response.headers["content-disposition"];
          let fileName = "recibo-de-pagamento.pdf";

          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch.length === 2) fileName = fileNameMatch[1];
          }

          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          this.generatingReceipt = false;
        })
        .catch((e) => {
          console.log("erro gerar recibo", e);
          window.getApp.sendSnackMessage(
            "Recibo não pode ser gerado. Motivo: " + e.message,
            "error",
          );
          this.generatingReceipt = false;
        });
    },
  },
};
</script>
